import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import GigService from '../../services/gigService.js';
import * as gigActions from '../../actions/gigActions';
import * as genreActions from '../../actions/genreActions';
import roleTypes from '../../constants/roleTypes';
import Browse from './Browse';
import Search from './Search';
import Results from './Results';
import PageLoading from '../common/PageLoading';

class GigBrowsePage extends React.Component {
    constructor(props, context) {
        super(props, context);        
        this.setSelectedTab = this.setSelectedTab.bind(this);
    }

    componentWillMount() {
        this.props.actions.getGenres();
    }

    componentDidMount() {  
        $('#btnPop').on('click', function (e) {
            e.preventDefault();
            $('#popover').toggleClass('showpop');
            e.stopPropagation();
        });
        $('body').on('click', this.removePopOver);
    }

    componentWillUnmount() {
        $('body').off('click', this.removePopOver);
    }

    removePopOver(e) {
        if ($('#popover').hasClass('showpop')) {
            $('#popover').removeClass('showpop');
        }
    }

    setSelectedTab(event) {
        event.preventDefault();
        this.props.actions.setBrowseTab(event.target.name);
        this.props.actions.clearGigs();
    }

    render() {
        //const artist = this.props.artist;
        //const actions = this.props.actions;
        return (
            <div className="main">
                <MetaTags>
                    <title>Find Local Live Music Gigs - LoudUp</title>            
                    <meta id="description" name="description" content="Full listings of upcoming gigs. Filter by location and genre and check out the music by the artists and bands performing." />                
                </MetaTags>
                <div className="container">
                    <div className="block-inner">   
                        <div className="popbox">
                            <div id="popover" className="popover">
                                <a id="btnPop" href="#" className="btn-pop transition">
                                    <div className="dot" />
                                    <svg className="icon icn-music-alert transition">
                                        <use xlinkHref="#icn-music-alert" />
                                    </svg>
                                </a>
                                <div className="inner transition2">
                                    <p>Here at LoudUp, we are passionate about live music! Nothing beats the energy you get from seeing an artist play live. So find a gig in your area and show some support. The artists will feel all warm and fuzzy!</p>                         
                                </div>
                            </div>
                        </div>                        
                        <h1 className="section-alt">Gigs</h1>
                        <ul className="nav nav-tabs tabs-lined" role="tablist">
                            <li className={this.props.browse.selectedTab == 'browse' ? 'active' : ''}>
                                <a id="lnkBrowse" href="#" name="browse" className="transition" onClick={this.setSelectedTab}>BROWSE</a>
                            </li>
                            <li className={this.props.browse.selectedTab == 'search' ? 'active' : ''}>
                                <a id="lnkSearch" href="#" name="search" className="transition" onClick={this.setSelectedTab}>SEARCH</a>
                            </li>
                        </ul>
                        <div id="browse" className="tab-content" style={{minHeight:'200px'}}>
                            <div className="tab-pane active">
                                <div id="browseSearchContent"className="search-with-filters">
                                    { this.props.browse.selectedTab == 'browse' ? 
                                        <Browse roleType={this.roleType} actions={this.props.actions} searchCriteria={this.props.browse.searchCriteria} searchError={this.props.browse.browseError} genres={this.props.genres} genreParam={this.props.match.params.genre} associationParam={this.props.match.params.association} user={this.props.user} />
                                        : <Search roleType={this.roleType} actions={this.props.actions} keyword={this.props.browse.keyword} searchError={this.props.browse.searchError} />
                                    }
                                </div>
            
                                <div id="searchresults" style={{paddingTop: 0}}>
                                    <Results roleType={this.roleType} results={this.props.browse.results} actions={this.props.actions} loadingStatus={this.props.browse.loadingStatus} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

GigBrowsePage.propTypes = {
    browse: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    genres: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    user: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { browse: state.gigs.browse, genres: state.genres, user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //gig actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, gigActions, genreActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GigBrowsePage);
